import { getActivation } from '@/_shared/components/activations/registry';
import { Card, CardContent, CardHeader, CardTitle } from '@/_shared/components/ui/card';

import type { Workflow } from '../types';

export function ActionSection({ workflow }: { workflow: Workflow }): React.ReactElement {
  const activation = getActivation(workflow.actionType);

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          {activation && <activation.icon size={16} className="text-muted-foreground" />}
          <CardTitle className="text-sm">Action</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        {activation && workflow.actionConfigSafe ? (
          <activation.ConfigSummary config={workflow.actionConfigSafe} />
        ) : (
          <p className="text-sm text-muted-foreground">
            {workflow.actionType === 'slack_webhook' ? 'Slack Webhook' : 'Email (Resend)'}
          </p>
        )}
      </CardContent>
    </Card>
  );
}
